import React, { useState } from "react";
import { useLang } from "../context/LangContext";
import { createLead } from "../lib/api";
import { toast } from "sonner";

const SERVICES = [
  { value: "individual", labelFr: "Séance individuelle (1 500 €/h)", labelEn: "Individual session (€1,500/h)" },
  { value: "deployment", labelFr: "Déplacement (sur devis)", labelEn: "Deployment (on quote)" },
  { value: "capacity", labelFr: "Journée (10–12 personnes)", labelEn: "Full day (10–12 people)" },
  { value: "other", labelFr: "Autre / Sur devis", labelEn: "Other / On quote" },
];

export default function ContactForm({ source = "contact", compact = false }) {
  const { lang, t } = useLang();
  const [data, setData] = useState({ name: "", email: "", phone: "", service: "", preferred_date: "", preferred_time: "", location: "", message: "" });
  const [loading, setLoading] = useState(false);

  const change = (e) => setData({ ...data, [e.target.name]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!data.name || !data.email) { toast.error(t("form.required")); return; }
    setLoading(true);
    try {
      await createLead({ ...data, source, language: lang });
      toast.success(t("form.success"));
      setData({ name: "", email: "", phone: "", service: "", preferred_date: "", preferred_time: "", location: "", message: "" });
    } catch (err) {
      toast.error(t("form.error"));
    } finally { setLoading(false); }
  };

  return (
    <form onSubmit={submit} className="grid grid-cols-1 md:grid-cols-2 gap-4" data-testid={`contact-form-${source}`}>
      <input name="name" value={data.name} onChange={change} required className="input-luxe" placeholder={t("form.name") + " *"} data-testid="form-name" />
      <input name="email" type="email" value={data.email} onChange={change} required className="input-luxe" placeholder={t("form.email") + " *"} data-testid="form-email" />
      <input name="phone" value={data.phone} onChange={change} className="input-luxe" placeholder={t("form.phone")} data-testid="form-phone" />
      <select name="service" value={data.service} onChange={change} className="input-luxe" data-testid="form-service">
        <option value="">{t("form.service")}</option>
        {SERVICES.map((s) => <option key={s.value} value={s.value}>{lang === "fr" ? s.labelFr : s.labelEn}</option>)}
      </select>
      {!compact && (
        <>
          <input name="preferred_date" type="date" value={data.preferred_date} onChange={change} className="input-luxe" placeholder={t("form.date")} data-testid="form-date" />
          <input name="preferred_time" type="time" value={data.preferred_time} onChange={change} className="input-luxe" placeholder={t("form.time")} data-testid="form-time" />
          <input name="location" value={data.location} onChange={change} className="input-luxe md:col-span-2" placeholder={t("form.location")} data-testid="form-location" />
        </>
      )}
      <textarea name="message" value={data.message} onChange={change} rows={compact ? 3 : 4} className="input-luxe md:col-span-2" placeholder={t("form.message")} data-testid="form-message" />
      <div className="md:col-span-2 flex justify-end pt-2">
        <button type="submit" disabled={loading} className="btn-gold" data-testid="form-submit">
          {loading ? "…" : t("form.submit")}
        </button>
      </div>
    </form>
  );
}
